"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientDashboard = void 0;
const mithril_1 = __importDefault(require("mithril"));
const moment_1 = __importDefault(require("moment"));
const app_1 = require("../../../app");
const helpers_1 = require("../../../utils/helpers");
const alert_box_1 = require("../../../widgets/alert_box");
const form_for_1 = require("../../../widgets/form_for");
const notification_center_1 = require("../../../widgets/notification_center");
let updates;
function renderRemainingCredits() {
    let content = "Chargement";
    if (updates) {
        content = (0, form_for_1.columns)((0, helpers_1.kpi)((0, helpers_1.minutesToUnit)(updates.total_bookable), "Crédit restant utilisable", (0, helpers_1.ifTrue)(updates.total_not_confirmed != 0, `et ${(0, helpers_1.minutesToUnit)(updates.total_not_confirmed)} déjà réservés`)), (0, helpers_1.kpi)(updates.total_contracts, "Forfait(s) en cours"));
    }
    return (0, helpers_1.card)("Mon compte", [
        content,
        (0, helpers_1.level)({
            right: (0, mithril_1.default)("a", { href: "#/me/contracts&" }, "Voir mes forfait(s) en cours")
        })
    ]);
}
function renderIncomingBookings() {
    if (updates) {
        let items = [];
        if (updates.incoming_bookings.length > 0) {
            updates.incoming_bookings.forEach(b => {
                var _a;
                items.push((0, helpers_1.card)(undefined, (0, mithril_1.default)("div", (0, helpers_1.level)({
                    left: (0, mithril_1.default)("div", (0, helpers_1.iconSpan)("fa-calendar"), (0, mithril_1.default)("span", `${(0, moment_1.default)(b.from).format("LLLL")}`), (0, mithril_1.default)("br"), (0, mithril_1.default)(".is-size-7", (0, helpers_1.iconSpan)("fa-home"), (0, mithril_1.default)("span", (_a = b.room) === null || _a === void 0 ? void 0 : _a.name))),
                    right: (0, mithril_1.default)("div", (0, helpers_1.iconSpan)("fa-clock"), (0, mithril_1.default)("span", (0, helpers_1.minutesToString)(b.duration)))
                }))));
            });
        }
        return (0, helpers_1.card)("Réservations à venir", (0, helpers_1.ifTrue)(items.length != 0, items, (0, notification_center_1.notificationBox)((0, mithril_1.default)("p", (0, mithril_1.default)("span", "Aucune réservation de prévue. "), (0, mithril_1.default)("a", { href: "#/calendar/bookings&" }, "Cliquez ici pour réserver")), "success")));
    }
    else {
        return (0, helpers_1.card)("Annonces", "Chargement...");
    }
}
function renderAlerts() {
    let items = [];
    if (updates) {
        if (updates.has_waiting_payment) {
            items.push((0, alert_box_1.alertBox)({
                content: [
                    "Forfait en attente de règlement, merci de bien vouloir régulariser cette situation au plus vite."
                ],
                level: "danger"
            }));
        }
        if (updates.has_mail) {
            items.push((0, alert_box_1.alertBox)({
                content: "Du courrier à votre nom est arrivé à l'accueil du centre Sésame!",
                level: "warning"
            }));
        }
        if (items.length == 0) {
            items.push((0, alert_box_1.alertBox)({ content: "Aucune alerte", level: "success" }));
        }
        if (updates.announces.length > 0) {
            updates.announces.forEach(ann => {
                items.push((0, notification_center_1.notificationBox)((0, mithril_1.default)("div", (0, mithril_1.default)("small", `Concernant le ${(0, moment_1.default)(ann.starts_at).format("dddd DD MMMM YYYY")}`), (0, mithril_1.default)("h2", ann.title), (0, mithril_1.default)("p", mithril_1.default.trust(ann.content.replace(/\n/g, "<br>")))), "info", "" + ann.id, () => {
                    if (updates) {
                        let idx = updates.announces.indexOf(ann);
                        updates.announces.splice(idx, 1);
                        app_1.App.get(`/announces/${ann.id}/read`);
                    }
                }));
            });
        }
        return (0, helpers_1.card)("Mes alertes", items);
    }
    else {
        return (0, helpers_1.card)("Mes alertes", "Chargement...");
    }
}
exports.ClientDashboard = {
    oncreate() {
        app_1.App.get("/me/updates").then((x) => {
            updates = x;
        });
    },
    view() {
        return (0, mithril_1.default)(".container", { style: "padding: 0px 1em;" }, (0, helpers_1.level)({ left: [] }), (0, form_for_1.columns)(renderRemainingCredits()), (0, form_for_1.columns)(renderIncomingBookings(), renderAlerts()), (0, form_for_1.columns)((0, helpers_1.card)("Documents legaux", (0, mithril_1.default)("ul", (0, mithril_1.default)("li", (0, mithril_1.default)("a", { target: "_blank", href: "/cgu.pdf" }, "Conditions Générales d'Utilisation")), (0, mithril_1.default)("li", (0, mithril_1.default)("a", { target: "_blank", href: "/politique_confidentialite.pdf" }, "Politique de Confidentialité"))))));
    }
};
